export default "__VITE_ASSET__ScOXj1TI__"